import React from "react"
import { CoinScopeUtil, UserPrivateDocument } from "popopo-msg"
import { formatDateTime } from "../../lib/util"

type Props = {
  coinBalances: UserPrivateDocument["coin_balance_list"]
}

const formatExpiry = (expiry: number | null): string => {
  if (expiry === null) {
    return "無期限"
  }
  return formatDateTime(expiry)
}

export const UserCoinBalanceList = (props: Props) => {
  if (props.coinBalances.length === 0) {
    return <p>コイン残高はありません</p>
  }

  return (
    <div className="card w-100">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>種別</th>
                <th>残高</th>
                <th>有効期限</th>
              </tr>
            </thead>
            <tbody>
              {props.coinBalances.map((balance, index) => (
                <tr key={index}>
                  <td>{CoinScopeUtil.toLabel(balance.scope)}</td>
                  <td>{balance.total} コイン</td>
                  <td>{formatExpiry(balance.expiry)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
